import React from 'react';

import ProceedNextStep from '@/components/shared/auth/ProceedNextStep';
import useSignUpEmail from '@/components/shared/auth/useSignUpEmail';

export type CateringSignUpEmailProps = {
  token: string;
};

const CateringSignUpEmail: React.FC<CateringSignUpEmailProps> = ({ token }) => {
  const { form, onSubmit, back, next, canProceed } = useSignUpEmail();

  const additionalFields = {
    sign_up: 'true',
    terms_of_service: `${form.values.accepted}`,
  };

  return (
    <div id="auth-form" className="row-fluid">
      <form className="form-elements" onSubmit={onSubmit}>
        <div className="row-fluid">
          <h4 className="align-left">Email</h4>
          <input
            name="email"
            type="text"
            aria-required="true"
            placeholder="Enter your login email"
            className={`${form.errors.email ? 'error' : ''}`}
            autoFocus
            required
            autoComplete="username"
            {...form.getInputProps('email')}
          />
          {form.errors.email ? (
            <p className="register-validation-message">{form.errors.email}</p>
          ) : null}
        </div>
        <div style={{ marginBottom: '10px' }}>
          <input
            type="checkbox"
            name="terms_of_service"
            className="fooda-checkbox"
            required
            style={{ marginLeft: 0 }}
            {...form.getInputProps('accepted', { type: 'checkbox' })}
          />
          <label htmlFor="terms_of_service">
            <span>I accept</span>{' '}
            <a href="https://www.fooda.com/terms-of-use" target="_blank" rel="noreferrer">
              Fooda&lsquo;s Terms of Service
            </a>
          </label>
        </div>
        <div className="row-fluid">
          <button type="submit" className="btn btn-info fooda-colors" disabled={canProceed}>
            {next ? 'Please wait...' : 'Continue'}
          </button>
        </div>
      </form>
      {next ? (
        <ProceedNextStep
          email={form.values.email}
          token={token}
          onError={back}
          onComplete={back}
          additionalFields={additionalFields}
        />
      ) : null}
    </div>
  );
};

export default CateringSignUpEmail;
